import styled from 'styled-components';

export const LiveArenaWidgetLogoBox = styled.div`
    background: url(${props => props.theme.images.liveArena.liveArenaWidget.logo.toString()});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    height: 100%;
    margin-left: 5px;
    width: 196px;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin-left: 0px;
        width: 101px;
    }
`;
